(function() {
    'use strict';
 
 
 a3_pilot_reports.controller('MessageCtrl',MessageCtrl);
    
/* @ngInject */ 
function MessageCtrl($scope, $location, MessageFactory, $filter, $sce) {
				
        var messages = [];

        $scope.messages = MessageFactory.getMessagesFromStorage();
        messages = $scope.messages;

        $scope.state = 'messages'

        //Initialized scope variables

        $scope.openMessage = openMessage;
        $scope.isEnabled = false;

        $scope.messageCount = messages.length;

        $scope.trustAsHtml = trustAsHtml;
    
        $scope.setupView = setupView;
    
         /**
         * Trust this html style text
         * @memberof MessageCtrl
         * @param {string} body The body message
         */ 
        function trustAsHtml(body){
            return $sce.trustAsHtml(body);
        }

         /**
         * Setup the message View
         * @memberof MessageCtrl
         * @param {boolean} isEnabled Show only unread messages
         */  
        function setupView(isEnabled) {
            $scope.messages = $filter('messageFilter')(messages, isEnabled);
        }

        /**
         * View Selected message
         * @memberof MessageCtrl
         * @param {object} message The selected Message
         */
        function openMessage(message) {
            if (message.ReadDt == null) {
                MessageFactory.markReaden(message.Id);
                message.ReadDt = new Date();
            }
        }

};
		
 
 })();   